import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/ConsultaInicialGratuita";
import { pageHead, breadcrumbJsonLd, faqJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/consulta-inicial-gratuita")({
  head: () =>
    pageHead({
      title: "Consulta inicial gratuita com nutricionista na Austrália | Clara Camille",
      description:
        "Agende sua consulta inicial gratuita com nutricionista brasileira na Austrália. 30 minutos para entender seus objetivos e como posso te ajudar. Sem compromisso.",
      path: "/consulta-inicial-gratuita",
      jsonLd: [
        faqJsonLd(faqItems),
        breadcrumbJsonLd([{ name: "Consulta inicial gratuita", path: "/consulta-inicial-gratuita" }]),
      ],
    }),
  component: Page,
});
